<template>
  <div class="data_statistics_wrap">
    <Header></Header>
    <div class="data_statistics_main">
      <div class="data_statistics_top">
        <div class="data_statistics_con_left">
          <div class="platform_access_statistics">
            <h2>
              <i class="el-icon-s-data"></i> 平台访问统计 
              <span>{{platformVisits.time}}</span>
              <el-button @click="updata">数据更新</el-button>
              <el-button @click="refresh">刷新</el-button>
            </h2>
            <ul>
              <li>
                <b>{{platformVisits.num | formatStr}}</b>
                <span>平台访问人数</span>
              </li>
              <li>
                <b>{{platformVisits.frequency | formatStr}}</b>
                <span>平台访问频次</span>
              </li>
              <li>
                <b>{{platformVisits.pc | formatStr}}</b>
                <span>PC端访问频次</span>
              </li>
              <li>
                <b>{{platformVisits.app | formatStr}}</b>
                <span>移动端访问频次</span>
              </li>
            </ul>
            <div class="online_visits_num">
              <p class="online_visits_num_title">在线访问数：<span>{{onlineVisitsNum | formatStr}}</span></p>
              <div class="broken_line_diagram">
                <ve-line
                :data="onlineVisitsData" 
                :settings="chartSettings" 
                :extend="peopleExtend"
                width="98%" 
                height="300px"
                :legend-visible="false"
                :colors="onlineVisitsColors"></ve-line>
              </div>
            </div>
          </div>
          <div class="teaching_behavior_statistics">
            <h2><i class="el-icon-s-data"></i> 教学行为统计</h2>
            <ul>
              <li>
                <b>{{teachingBehavior.classNum | formatStr}}</b>
                <span>教学班总数</span>
              </li>
              <li>
                <b>{{teachingBehavior.courseVisitNum | formatStr}}</b>
                <span>课程访问频次</span>
              </li>
              <li>
                <b>{{teachingBehavior.mentoringNum | formatStr}}</b>
                <span>答疑总数</span>
              </li>
              <li>
                <b>{{teachingBehavior.sponsorAttendanceNum | formatStr}}</b>
                <span>发起考勤数</span>
              </li>
              <li>
                <b>{{teachingBehavior.informNum | formatStr}}</b>
                <span>发布通知数</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="user_distribution_statistics">
          <h2><i class="el-icon-s-data"></i> 用户分布统计</h2>
          <div class="user_distribution_item">
            <div class="user_type_distribution">
              <p>用户类型分布：<b>300</b></p>
              <div class="custom_extend_wrap">
                <ve-ring :data="userTypeData" width="150px" height="150px" data-msg="type" :events="chartEvents" :extend="chartExtend" :settings="userDistributionSetting" :colors="userTypeColor" :title="userTypeTitle"></ve-ring>
                <ul class="custom_extend">
                  <!-- <li>
                    <b class="b_0" v-if="userTypeList.length">{{userTypeList[0].num}}</b>
                    <span>教师</span>
                  </li>
                  <li>
                    <b class="b_1" v-if="userTypeList.length">{{userTypeList[1].num}}</b>
                    <span>学生</span>
                  </li> -->
                  <li v-for="(item, index) in userTypeList" :key="index">
                    <b class="b_1">{{item.num}}</b>
                    <span>{{item.name}}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="user_gender_distribution">
              <p>学生性别分布</p>
              <div class="custom_extend_wrap">
                <ve-ring :data="userGenderData" width="150px" height="150px" data-msg="sex" :events="chartEvents" :extend="chartExtend" :settings="userDistributionSetting" :colors="userGenderColor" :title="userGenderTitle"></ve-ring>
                <ul class="custom_extend">
                  <!-- <li>
                    <b class="b_0" v-if="userGenderList.length">{{userGenderList[0].num}}</b>
                    <span>男生</span>
                  </li>
                  <li>
                    <b class="b_1" v-if="userGenderList.length">{{userGenderList[1].num}}</b>
                    <span>女生</span>
                  </li> -->
                  <li v-for="(item, index) in userGenderList" :key="index">
                    <b class="b_1">{{item.num}}</b>
                    <span>{{item.name}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="user_provinces_distribution">
            <p>学生省份分布</p>
            <div class="custom_extend_wrap">
              <ve-ring :data="userProvincesData" width="150px" height="150px" data-msg="city" :events="chartEvents" :extend="chartExtend" :settings="userProvincesSetting" :colors="userProvincesColor" :title="userProvincesTitle"></ve-ring>
              <ul class="custom_extend" v-if="userProvincesList.length>0">
                <li v-for="(item, i) in userProvincesList" :key="i">
                  <b :class="'b_'+i">{{item.num}}</b>
                  <span>{{item.name}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="user_year_distribution">
            <p>学生入学年份分布</p>
            <div class="custom_extend_wrap">
              <ve-ring :data="userYearData" width="150px" height="150px" data-msg="year" :events="chartEvents" :extend="chartExtend" :settings="userYearSetting" :colors="userYearColor" :title="userYearTitle"></ve-ring>
              <ul class="custom_extend" v-if="userYearList.length>0">
                <li v-for="(item, i) in userYearList" :key="i">
                  <b :class="'b_'+i">{{item.num}}</b>
                  <span>{{item.name}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="learning_behavior_statistics">
        <h2><i class="el-icon-s-data"></i> 学习行为统计</h2>
        <div class="learning_behavior_statistics_top">
          <ul>
            <li>
              <p>人均课程进度</p>
              <el-progress type="circle" :percentage="studyBehavior.avgCourseSchedule" :color="onlineVisitsColors[0]" :stroke-width="16" stroke-linecap="square"></el-progress>
              <p>参与统计学生：<b>{{studyBehavior.avgCourseScheduleNum}}</b>人</p>
            </li>
            <li>
              <p>参与讨论度</p>
              <el-progress type="circle" :percentage="studyBehavior.discussionDegree" :color="onlineVisitsColors[0]" :stroke-width="16" stroke-linecap="square"></el-progress>
              <p>讨论主题总计：<b>{{studyBehavior.discussionDegreeNum}}</b>条</p>
            </li>
            <li>
              <p>出勤率</p>
              <el-progress type="circle" :percentage="studyBehavior.attendanceRate" :color="onlineVisitsColors[0]" :stroke-width="16" stroke-linecap="square"></el-progress>
              <p>考勤次数总计：<b>{{studyBehavior.attendanceNum}}</b>次</p>
            </li>
          </ul>
          <div class="learning_behavior_right">
            <div class="learning_behavior_item">
              <div class="learning_behavior_item_left">
                <b>{{studyBehavior.avgLearnDuration | filterTime}}</b>
                <span>人均学习时长</span>
              </div>
              <div class="learning_behavior_item_right">
                <p>参与统计学生：<b>{{studyBehavior.avgLearnDurationNum}}</b> 人</p>
              </div>
            </div>
            <div class="learning_behavior_item">
              <div class="learning_behavior_item_left">
                <b>{{studyBehavior.avgOpenNote}}条</b>
                <span>人均公开笔记</span>
              </div>
              <div class="learning_behavior_item_right">
                <p>公开笔记总数：<b>{{studyBehavior.openNoteNum}}</b> 条</p>
              </div>
            </div>
          </div>
        </div>
        <div class="learning_behavior_statistics_bot">
          <div class="broken_line_diagram">
            <div class="broken_line_diagram_title">
              <p>
                <span>日均学习人数：</span>
                <b>{{avgLearnNum}}</b>
                <span>累计学习人数：</span>
                <b>{{totalLearnNum | formatStr}}</b>
              </p>
              <p>
                <b :class="learnType==1?'active':''" @click="tabLearnType(1)">近7日</b>
                <b :class="learnType==2?'active':''" @click="tabLearnType(2)">近8周</b>
                <b :class="learnType==3?'active':''" @click="tabLearnType(3)">近1年</b>
              </p>
            </div>
            <ve-line
            :data="learnChartData" 
            :settings="chartSettings" 
            :extend="peopleExtend"
            width="98%" 
            height="350px"
            :legend-visible="false"
            :colors="colors" v-if="learnChartData.rows.length"></ve-line>
            <div v-else class="no_data">
              <img src="../../../../static/images/wujieguo.png" alt="">
              <p>暂无统计结果</p>
            </div>
          </div>
        </div>
      </div>
      <div class="data_statistics_bot">
        <div class="data_statistics_bot_item">
          <h2><i class="el-icon-s-data"></i> 活跃度TOP教师 <span>按平台访问频次排序</span></h2>
          <ul>
            <li v-for="(item, i) in teacherRanking" :key="i">
              <span>{{i+1}}</span>
              <span>{{item.userName}}</span>
              <span>{{item.visitNum | formatStr}}</span>
            </li>
            <li v-for="(item, i) in (10-teacherRanking.length)" :key="i+teacherRanking.length">
              <span>{{item+teacherRanking.length}}</span>
              <span>--</span>
              <span>--</span>
            </li>
          </ul>
        </div>
        <div class="data_statistics_bot_item">
          <h2><i class="el-icon-s-data"></i> 活跃度TOP学生 <span>按平台访问频次排序</span></h2>
          <ul>
            <li v-for="(item, i) in studentRanking" :key="i">
              <span>{{i+1}}</span>
              <span>{{item.userName}}</span>
              <span>{{item.visitNum | formatStr}}</span>
            </li>
            <li v-for="(item, i) in (10-studentRanking.length)" :key="i+studentRanking.length">
              <span>{{item+studentRanking.length}}</span>
              <span>--</span>
              <span>--</span>
            </li>
          </ul>
        </div>
        <div class="data_statistics_bot_item">
          <h2><i class="el-icon-s-data"></i> 活跃度TOP班级 <span>按平台访问频次排序</span></h2>
          <ul>
            <li v-for="(item, i) in classRanking" :key="i">
              <span>{{i+1}}</span>
              <span>{{item.className}}</span>
              <span>{{item.visitNum | formatStr}}</span>
            </li>
            <li v-for="(item, i) in (10-classRanking.length)" :key="i+classRanking.length">
              <span>{{item+classRanking.length}}</span>
              <span>--</span>
              <span>--</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../../header/header'
  import * as api from "../../../api/HNstatisticsApi"
  export default {
    components: {
      Header
    },
    data() {
      this.chartSettings = {//折线图settings
        stack: { '用户': ['访问人数'] },
        area: true,
        itemStyle:{ //面积图颜色设置
          color:{
            type:'linear',
            x:0,
            y:0,
            x2:0,
            y2:1,
            colorStops:[
              {
                offset: 0,
                color: 'rgba(83,151,247,0.8)', // 0% 处的颜色
              }, 
              {
                offset: 1, 
                color: 'rgba(255,255,255,1)' // 100% 处的颜色
              },
            ],
            globalCoord: false
          }        
        },
      }
      this.peopleExtend = {//折线图隐藏legend
        series: {
          label: {
            normal: {
              show: true
            }
          }
        }
      }
      this.userDistributionTitle = {//环形图title样式
          // show: true,
          // text: '300人',
          // subtext: "用户",
        left: "center",
        top: "35%",
        textStyle: {
          fontSize: 18,
          color: '#0D141E',
          lineHeight: 16,
          fontWeight: 'bold',
        },
        subtextStyle: {
          fontSize: 12,
          color: '#858C96',
          lineHeight: 10
        }
      }
      var self = this
      this.chartEvents = {//环形图事件监听
        mouseover: function (e) {
          let dataMsg = e.event.event.target.parentNode.parentNode.parentNode.getAttribute('data-msg')
          if(dataMsg=='type'){ self.userTypeTitle.show = false }   
          if(dataMsg=='sex'){ self.userGenderTitle.show = false }
          if(dataMsg=='city'){ self.userProvincesTitle.show = false }
          if(dataMsg=='year'){ self.userYearTitle.show = false }
        },
        mouseout: function (e) {
          let dataMsg = e.event.event.target.parentNode.parentNode.parentNode.getAttribute('data-msg')
          if(dataMsg=='type'){ self.userTypeTitle.show = true }   
          if(dataMsg=='sex'){ self.userGenderTitle.show = true }
          if(dataMsg=='city'){ self.userProvincesTitle.show = true }
          if(dataMsg=='year'){ self.userYearTitle.show = true }
        }
      }
      this.chartExtend = {//环形图Extend
        legend: { show: false },  
        series: {
          center: ['50%', '50%']
        }
      }
      this.userDistributionSetting = {//环形图settings
        radius: ["60%", "80%"],
        label: {//去除饼图的指示折线label
          normal: {
            show: false,
            position: "center",
            formatter: params => {
              return [
                `{a|${params.percent}%}`,
                `{b|${params.name}}`
              ].join('\n')
            },
            rich: {
              a: {
                fontSize: 18,
                color: '#0D141E',
                lineHeight: 25,
                fontWeight: 'bold',
              },
              b: {
                fontSize: 12,
                color: '#858C96',
                lineHeight: 17,
                height: 60,
              },
            },
          },
          emphasis: {
            show: true,
            formatter: params => {
              return [
                `{a|${params.percent}%}`,
                `{b|${params.name}}`
              ].join('\n')
            },
            rich: {
              a: {
                fontSize: 18,
                color: '#0D141E',
                lineHeight: 25,
                fontWeight: 'bold',
              },
              b: {
                fontSize: 12,
                color: '#858C96',
                lineHeight: 17,
              },
            }
          }
        },
        labelLine: {
          normal: {
            label: {
              show: true,
              formatter: "({d}%)"
            },
            labelLine: { show: false }
          }
        },
        textStyle: { color: "#333" },// 全局字体样式
        // limitShowNum: 4,//限制最大数量
      }
      return {
        progress: 0.4,
        postAccuracyColor: ['#5397F7', '#FD785A', '#FECB61', '#34D3B0', '#FFB23C'],
        learnChartData: { //最近学习人数
          columns: ['时间', '访问人数'],
          rows: []
        },
        learnType: 1,//（1：日；2：周；3：月）
        avgLearnNum: 0,//日均学习人数
        totalLearnNum: 0,//累计学习人数
        colors: ['#5397F7'],
        //=======================用户分布统计==================================
        userTypeData: {//用户类型分布数据
          columns: ['身份', '访问用户'],
          rows: [
            { '身份': '教师', '访问用户': 0 },
            { '身份': '学生', '访问用户': 0 },
          ]
        },
        userGenderData: {//学生性别分布数据
          columns: ['性别', '访问用户'],
          rows: [
            { '性别': '男生', '访问用户': 0 },
            { '性别': '女生', '访问用户': 0 },
          ]
        },
        userProvincesData: {//学生省份分布数据
          columns: ['省份', '访问用户'],
          rows: []
        },
        userYearData: {//学生入学年份分布数据
          columns: ['年份', '访问用户'],
          rows: []
        },
        userTypeTitle: {//用户类型分布title
          show: true,
          text: '',
          subtext: "用户",
          ...this.userDistributionTitle
        },
        userGenderTitle: {//学生性别分布title
          show: true,
          text: '',
          subtext: "学生",
          ...this.userDistributionTitle
        },
        userProvincesTitle: {//学生省份分布title
          show: true,
          text: '',
          subtext: "学生",
          ...this.userDistributionTitle
        },
        userYearTitle: {//学生入学年份分布title
          show: true,
          text: '',
          subtext: "学生",
          ...this.userDistributionTitle
        },
        userTypeColor: ["#4C98F6", "#7F1978"],//用户类型分布颜色
        userGenderColor: ["#5397F7", "#E53D77"],//学生性别分布颜色
        userProvincesColor: ["#F9DF38", "#EA683E", "#AC1948", "#4C98F6", "#55195C"],//学生省份分布颜色
        userYearColor: ["#FBEE4A", "#FE8451", "#C92B5D", "#742574"],//学生入学年份分布颜色
        userProvincesSetting: {
          ...this.userDistributionSetting,
          limitShowNum: 4,//限制最大数量
        },
        userYearSetting: {
          ...this.userDistributionSetting,
          limitShowNum: 3,//限制最大数量
        },
        userTypeList: [],
        userGenderList: [],
        userProvincesList: [],
        userYearList: [],
        //=====================================================================
        deptId: sessionStorage.getItem('deptId'),
        // deptId: 80,
        platformVisits: {//平台访问统计
          time: 0,
          num: 0,
          frequency: 0,
          pc: 0,
          app: 0,
        },
        onlineVisitsData: {//在线访问数折线图
          columns: ['时间', '访问人数'],
          rows: [
            {'访问人数': 0, '时间': "8:00"},
            {'访问人数': 0, '时间': "9:00"},
            {'访问人数': 0, '时间': "10:00"},
            {'访问人数': 0, '时间': "11:00"},
            {'访问人数': 0, '时间': "12:00"},
            {'访问人数': 0, '时间': "13:00"},
            {'访问人数': 0, '时间': "14:00"},
            {'访问人数': 0, '时间': "15:00"},
            {'访问人数': 0, '时间': "16:00"},
            {'访问人数': 0, '时间': "17:00"},
            {'访问人数': 0, '时间': "18:00"},
            {'访问人数': 0, '时间': "19:00"},
            {'访问人数': 0, '时间': "20:00"},
            {'访问人数': 0, '时间': "21:00"},
            {'访问人数': 0, '时间': "22:00"},
          ]
        },
        onlineVisitsColors: ['#5397F7'],
        onlineVisitsNum: 0, //在线访问数折线图
        //教学行为统计
        teachingBehavior: {
          classNum: 0,//教学班总数
          courseVisitNum: 0,//课程访问频次
          mentoringNum: 0,//答疑总数
          sponsorAttendanceNum: 0,//发起考勤数
          informNum: 0,//发布通知数
        },
        //学习行为统计
        studyBehavior: {
          avgCourseSchedule: 0,//人均课程进度
          avgCourseScheduleNum: 0,//参与统计学生
          discussionDegree: 0,//参与讨论度
          discussionDegreeNum: 0,//讨论主题总条数
          attendanceRate: 0,//出勤率
          attendanceNum: 0,//考勤数
          avgLearnDuration: 0,//人均学习时长
          avgLearnDurationNum: 0,//参与统计学生
          avgOpenNote: 0,//人均公开笔记
          openNoteNum: 0,//公开笔记总数
        },
        classRanking: [],//班级排名
        teacherRanking: [],//教师排名
        studentRanking: [],//学生排名
      }
    },
    mounted(){
      this.init()
    },
    watch: {
      teacherRanking: function(val){
        // console.log(val)
      },
      studentRanking: function(val){
        // console.log(val)
      }
    },
    computed: {
      
    },
    filters: {
      filterTime(minutes){
        return (Math.floor(minutes/60) + "时" + (minutes%60) + "分" );
      },
      formatStr(num) {
		    var reg=/\d{1,3}(?=(\d{3})+$)/g; 
		    return (num + '').replace(reg, '$&,');
      },
    },
    methods:{
      tabLearnType(type){//切换日周年
        this.learnType = type
        this.getRecentLearningNum(type)
      },
      getRecentLearningNum(type){//查询最近学习人数（日周年）
        api.recentLearningNum({
          "deptId": this.deptId,
          "type": type//查询类型（1：日；2：周；3：月）
        }).then(rs=>{
          if(rs.code==0){
            this.learnChartData.rows = []
            if(rs.data && rs.data.list.length>0){
              rs.data.list.forEach(v=>{
                let obj = { '访问人数': v.num, '时间': v.time }
                this.learnChartData.rows.push(obj)
              })
              this.avgLearnNum = rs.data.avgLearnNum
              this.totalLearnNum = rs.data.totalLearnNum
            }else{
              this.learnChartData.rows = []
            }
          }
        })
      },
      getPlatformVisitsNum(){//平台访问统计
        api.getPlatformVisitsNum(this.deptId).then(rs=>{
          if(rs.code==0){
            if(rs.data){
              this.platformVisits = {
                time: rs.data.date,
                num: rs.data.visitNumber,
                frequency: rs.data.visitFrequency,
                pc: rs.data.pcVisitFrequency,
                app: rs.data.appVisitFrequency,
              }
            }
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      getOnlineVisitsNum(){//在线访问数
        api.getOnlineVisitsNum(this.deptId).then(rs=>{
          if(rs.code==0){
            if(rs.data){
              this.onlineVisitsData.rows = [
                {'访问人数': rs.data.eight, '时间': "8:00"},
                {'访问人数': rs.data.nine, '时间': "9:00"},
                {'访问人数': rs.data.ten, '时间': "10:00"},
                {'访问人数': rs.data.eleven, '时间': "11:00"},
                {'访问人数': rs.data.twelve, '时间': "12:00"},
                {'访问人数': rs.data.thirteen, '时间': "13:00"},
                {'访问人数': rs.data.fourteen, '时间': "14:00"},
                {'访问人数': rs.data.fifteen, '时间': "15:00"},
                {'访问人数': rs.data.sixteen, '时间': "16:00"},
                {'访问人数': rs.data.seventeen, '时间': "17:00"},
                {'访问人数': rs.data.eighteen, '时间': "18:00"},
                {'访问人数': rs.data.nineteen, '时间': "19:00"},
                {'访问人数': rs.data.twenty, '时间': "20:00"},
                {'访问人数': rs.data.twentyOne, '时间': "21:00"},
                {'访问人数': rs.data.twentyTwo, '时间': "22:00"},
              ]
              let arr = []
              this.onlineVisitsData.rows.forEach(v=>{
                arr.push(v.访问人数)
              })
              this.onlineVisitsNum = eval(arr.join('+'))
            }
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      getBehavior(){//用户行为
        api.getBehavior(this.deptId).then(rs=>{
          if(rs.code==0){
            if(rs.data){
              let avgCourseSchedule = rs.data.avgCourseSchedule ? rs.data.avgCourseSchedule.split('%')[0] : 0
              let discussionDegree = rs.data.discussionDegree ? rs.data.discussionDegree.split('%')[0] : 0
              let attendanceRate = rs.data.attendanceRate ? rs.data.attendanceRate.split('%')[0] : 0
              //教学行为统计
              this.teachingBehavior = {
                classNum: rs.data.classNum,//教学班总数
                courseVisitNum: rs.data.courseVisitNum,//课程访问频次
                mentoringNum: rs.data.mentoringNum,//答疑总数
                sponsorAttendanceNum: rs.data.sponsorAttendanceNum,//发起考勤数
                informNum: rs.data.informNum,//发布通知数
              }
              //学习行为统计
              this.studyBehavior = {
                avgCourseSchedule: Math.ceil(avgCourseSchedule*1),//人均课程进度
                avgCourseScheduleNum: rs.data.avgCourseScheduleNum,//参与统计学生
                discussionDegree: Math.ceil(discussionDegree*1),//参与讨论度
                discussionDegreeNum: rs.data.discussionDegreeNum,//讨论主题总条数
                attendanceRate: Math.ceil(attendanceRate*1),//出勤率
                attendanceNum: rs.data.attendanceNum,//考勤数
                avgLearnDuration: rs.data.avgLearnDuration,//人均学习时长
                avgLearnDurationNum: rs.data.avgLearnDurationNum,//参与统计学生
                avgOpenNote: rs.data.avgOpenNote,//人均公开笔记
                openNoteNum: rs.data.openNoteNum,//公开笔记总数
              }
            }
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      getUserActivity(type, list){//用户活跃度
        let that = this
        api.getUserActivity({
          deptId: 80,
          // deptId: that.deptId,
          userType: type
        }).then(rs=>{
          if(rs.code==0){
            that[list] = rs.data
          }else{
            that.$messageError(rs.msg)
          }
        })
      },
      geClassActivity(){//班级活跃度
        api.geClassActivity({
          deptId: this.deptId
        }).then(rs=>{
          if(rs.code==0){
            this.classRanking = rs.data
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      getUserType(){//用户类型
        api.getUserType(this.deptId).then(rs=>{
          if(rs.code==0){
            if(rs.data){
              this.$set(this.userTypeData,"rows",[
                { '身份': '教师', '访问用户': rs.data.teacherNumber },
                { '身份': '学生', '访问用户': rs.data.studentNumber },
              ])
              this.$nextTick(()=>{
                this.userTypeList = [
                  { 'name': '教师', 'num': rs.data.teacherNumber },
                  { 'name': '学生', 'num': rs.data.studentNumber },
                ]
              })
              this.userTypeTitle.text = rs.data.sumPeopleNumber + '人'
              this.userGenderTitle.text = rs.data.studentNumber + '人' 
              this.userProvincesTitle.text = rs.data.studentNumber + '人'
              this.userYearTitle.text = rs.data.studentNumber + '人'
            }else{
              this.userTypeTitle.text = 0 + '人'
              this.userGenderTitle.text = 0 + '人' 
              this.userProvincesTitle.text = 0 + '人'
              this.userYearTitle.text = 0 + '人'
            }
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      getGender(){//学生性别
        let that = this
        api.getGender(that.deptId).then(rs=>{
          if(rs.code==0){
            if(rs.data){
              that.$set(that.userGenderData,"rows",[
                { '性别': '男生', '访问用户': rs.data.manPeopleNumber },
                { '性别': '女生', '访问用户': rs.data.womanPeopleNumber },
              ])
              that.$nextTick(()=>{
                let man = { 'name': '男生', 'num': rs.data.manPeopleNumber }
                let woman = { 'name': '女生', 'num': rs.data.womanPeopleNumber }
                that.userGenderList.push(man,woman)
              })
            }
          }else{
            that.$messageError(rs.msg)
          }
        })
      },
      getProvince(){//学生省份
        api.getProvince(this.deptId).then(rs=>{
          if(rs.code==0){
            if(rs.data.length>0){
              let arr = []
              rs.data.forEach((v,i)=>{
                let obj = {'省份': v.provinceName, '访问用户': v.sumPeopleNumber}
                this.userProvincesData.rows.push(obj)
                if(i<5){
                  this.userProvincesList.push({ name: v.provinceName, num: v.sumPeopleNumber })
                }else{
                  arr.push(v.sumPeopleNumber)
                }
              })
              if(this.userProvincesList.length==5){
                arr.push(this.userProvincesList[4].num)
                this.userProvincesList[4].name = '其他'
                this.userProvincesList[4].num = eval(arr.join('+'))
              }
            }
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      getEnrollmentYear(){//学生入学年份
        api.getEnrollmentYear(this.deptId).then(rs=>{
          if(rs.code==0){
            if(rs.data.length>0){
              let arr = []
              rs.data.forEach((v,i)=>{
                let obj = {'年份': v.year, '访问用户': v.sumPeopleNumber}
                this.userYearData.rows.push(obj)
                if(i<4){
                  this.userYearList.push({ name: v.year, num: v.sumPeopleNumber })
                }else{
                  arr.push(Number(v.sumPeopleNumber))
                }
              })
              if(this.userYearList.length==4){
                arr.push(Number(this.userYearList[3].num))
                this.userYearList[3].name = '其他'
                this.userYearList[3].num = eval(arr.join('+'))
              }
            }
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      init(){
        this.getPlatformVisitsNum()//平台访问统计
        this.getOnlineVisitsNum()//在线访问数
        this.getBehavior()//用户行为
        this.getRecentLearningNum(1)//最近学习人数（日）
        this.getUserActivity(1,'teacherRanking')//用户活跃度-教师
        this.getUserActivity(2,'studentRanking')//用户活跃度-学生
        this.geClassActivity()//班级活跃度
        this.getUserType()//用户类型
        this.getGender()//学生性别
        this.getProvince()//学生省份
        this.getEnrollmentYear()//学生入学年份
      },
      updata(){
        api.updataDatacount({
          deptId: this.deptId
        }).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess(rs.msg)
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      refresh(){
        this.init()
        this.$messageSuccess('刷新成功')
      }
    }
  }
</script>
<style lang="scss">
  .data_statistics_wrap{
    width: 100%;
    height: 100%;
    background: #F6F8FB;
    .data_statistics_main{
      height: calc(100% - 64px);
      overflow: auto;
      h2{
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #0D141E;
        padding: 16px;
        i{
          color: #3587FA;
          margin-right: 5px;
        }
        span{
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
          color: #858C96;
          margin-left: 20px;
        }
      }
      .data_statistics_top{
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
        .data_statistics_con_left{
          margin-left: 16px;
          flex: 1;
          margin-right: 16px;
          .platform_access_statistics{
            height: 445px;
            background: #FFFFFF;
            h2{
              button{
                width: 72px;
                height: 28px;
                background: #5397F7;
                border-radius: 4px;
                padding: 0;
                float: right;
                margin-left: 10px;
                span{
                  margin: 0;
                  color: #fff;
                }
              }
            }
            ul{
              display: flex;
              justify-content: space-around;
              li{
                height: 95px;
                b{
                  font-size: 24px;
                  font-weight: 600;
                  line-height: 55px;
                  color: #0D141E;
                  letter-spacing: 2px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 24px;
                    height: 3px;
                    background: linear-gradient(180deg, #4E9BF7 0%, #347CED 100%);
                    border-radius: 3px;
                    position: absolute;
                    left: 0;
                    bottom: -10px;
                  }
                }
                span{
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 17px;
                  color: #858C96;
                  letter-spacing: 1px;
                  display: block;
                }
              }
            }
            .online_visits_num{
              .online_visits_num_title{
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                color: #0D141E;
                margin-left: 47px;
                span{
                  font-size: 20px;
                  font-weight: 600;
                  line-height: 28px;
                  color: #3587FA;
                  letter-spacing: 1px;
                }
              }
              .broken_line_diagram{
                .ve-line{
                  margin-left: 2%;
                } 
              }
            }
          }
          .teaching_behavior_statistics{
            height: 174px;
            background: #FFFFFF;
            margin-top: 16px;
            ul{
              display: flex;
              justify-content: space-around;
              li{
                height: 95px;
                b{
                  font-size: 24px;
                  font-weight: 600;
                  line-height: 60px;
                  color: #0D141E;
                  letter-spacing: 2px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 24px;
                    height: 3px;
                    background: linear-gradient(180deg, #4E9BF7 0%, #347CED 100%);
                    border-radius: 3px;
                    position: absolute;
                    left: 0;
                    bottom: -10px;
                  }
                }
                span{
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 17px;
                  color: #858C96;
                  letter-spacing: 1px;
                  display: block;
                }
              }
            }
          }
        }
        .user_distribution_statistics{
          width: 434px;
          height: 635px;
          background: #FFFFFF;
          margin-right: 16px;
          .user_distribution_item{
            display: flex;
            margin: 18px 10px 0;
            .user_type_distribution,.user_gender_distribution{
              flex: 1;
              p{
                font-size: 12px;
                font-weight: 400;
                line-height: 17px;
                color: #0D141E;
                letter-spacing: 1px;
                margin-left: 15px;
                b{
                  font-size: 14px;
                  font-weight: 600;
                  line-height: 20px;
                  color: #0D141E;
                  letter-spacing: 1px;
                }
              }
              .custom_extend_wrap{
                display: flex;
                ul{
                  margin: auto;
                  li{
                    b{
                      font-size: 16px;
                      font-weight: 600;
                      line-height: 26px;
                      color: #0D141E;
                      position: relative;
                      &::after{
                        content: "";
                        width: 16px;
                        height: 3px;
                        position: absolute;
                        left: 0;
                        bottom: -4px;
                      }
                    }
                    span{
                      font-size: 12px;
                      font-weight: 400;
                      line-height: 17px;
                      color: #858C96;
                      letter-spacing: 1px;
                      display: block;
                    }
                    &:first-child{
                      margin-bottom: 20px;
                    }
                  }
                }
              }
            }
            .user_type_distribution .custom_extend_wrap .b_0::after{ background: #4C98F6; }
            .user_type_distribution .custom_extend_wrap .b_1::after{ background: #7F1978; }
            .user_gender_distribution .custom_extend_wrap .b_0::after{ background: #5397F7; }
            .user_gender_distribution .custom_extend_wrap .b_1::after{ background: #E53D77; }
          }
          .user_provinces_distribution,.user_year_distribution{
            margin: 26px 10px 0;
            p{
              font-size: 12px;
              font-weight: 400;
              line-height: 17px;
              color: #0D141E;
              letter-spacing: 1px;
              margin-left: 15px;
            }
            .custom_extend_wrap{
              display: flex;
              ul{
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                li{
                  width: 33%;
                  padding-left: 5px;
                  box-sizing: border-box;
                  b{
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 26px;
                    color: #0D141E;
                    position: relative;
                    &::after{
                      content: "";
                      width: 16px;
                      height: 3px;
                      position: absolute;
                      left: 0;
                      bottom: -4px;
                    }
                  }
                  span{
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 17px;
                    color: #858C96;
                    letter-spacing: 1px;
                    display: block;
                  }
                }
              }
            }
          }
          .user_provinces_distribution .custom_extend_wrap .b_0::after{ background: #F9DF38; }
          .user_provinces_distribution .custom_extend_wrap .b_1::after{ background: #EA683E; }
          .user_provinces_distribution .custom_extend_wrap .b_2::after{ background: #AC1948; }
          .user_provinces_distribution .custom_extend_wrap .b_3::after{ background: #4C98F6; }
          .user_provinces_distribution .custom_extend_wrap .b_4::after{ background: #55195C; }
          .user_year_distribution .custom_extend_wrap .b_0::after{ background: #FBEE4A; }
          .user_year_distribution .custom_extend_wrap .b_1::after{ background: #FE8451; }
          .user_year_distribution .custom_extend_wrap .b_2::after{ background: #C92B5D; }
          .user_year_distribution .custom_extend_wrap .b_3::after{ background: #742574; }
        }
      }
      .learning_behavior_statistics{
        height: 700px;
        background: #FFFFFF;
        margin-top: 16px;
        margin-left: 16px;
        margin-right: 16px;
        .learning_behavior_statistics_top{
          display: flex;
          justify-content: space-between;
          ul{
            display: flex;
            flex: 1;
            justify-content: space-around;
            align-items: center;
            li{
              width: 200px;
              text-align: center;
              p{
                &:first-child{
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 17px;
                  color: #0D141E;
                  letter-spacing: 1px;
                  text-align: left;
                  margin-bottom: 23px;
                }
                &:last-child{
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 17px;
                  color: #858C96;
                  letter-spacing: 1px;
                  text-align: center;
                  margin-top: 15px;
                  b{
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    color: #0D141E;
                    letter-spacing: 1px;
                    margin: 0 5px;
                  }
                }
              }
            }
          }
          .learning_behavior_right{
            width: 434px;
            .learning_behavior_item{
              display: flex;
              align-items: center;
              justify-content: space-around;
              height: 120px;
              .learning_behavior_item_left{
                b{
                  font-size: 24px;
                  font-weight: 600;
                  line-height: 55px;
                  color: #0D141E;
                  letter-spacing: 2px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 24px;
                    height: 3px;
                    background: linear-gradient(180deg, #4E9BF7 0%, #347CED 100%);
                    border-radius: 3px;
                    position: absolute;
                    left: 0;
                    bottom: -10px;
                  }
                }
                span{
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 20px;
                  color: #858C96;
                  letter-spacing: 1px;
                  display: block;
                }
              }
              .learning_behavior_item_right{
                width: 200px;
                position: relative;
                p{
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 17px;
                  color: #858C96;
                  letter-spacing: 1px;
                  padding-left: 10px;
                  b{
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    color: #0D141E;
                  }
                }
                &::after{
                  content: "";
                  width: 1px;
                  height: 16px;
                  background: #99A0AA;
                  position: absolute;
                  left: 0;
                  top: 3px;
                }
              }
            }
          }
        }
        .learning_behavior_statistics_bot{
          .broken_line_diagram_title{
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 90%;
            margin: 20px auto 0;
            p:nth-child(1){
              span{
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                color: #0D141E;
                &:nth-child(3){
                  margin-left: 100px;
                }
              }
              b{
                font-size: 20px;
                font-weight: 600;
                line-height: 28px;
                color: #3587FA;
                letter-spacing: 1px;
              }
            }
            p:nth-child(2){
              b{
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                margin-left: 25px;
                position: relative;
                color: #858C96;
                cursor: pointer;
                &::after{
                  content: "/";
                  position: absolute;
                  left: -15px;
                  top: 0;
                  color: #858C96;
                }
                &:first-child{
                  &::after{
                    content: "";
                  }
                }
              }
              .active{
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                color: #5397F7;
              }
            }
          }
          .ve-line{
            margin-left: 2%;
          }
        }
      }
      .data_statistics_bot{
        display: flex;
        justify-content: space-between;
        .data_statistics_bot_item{
          flex: 1;
          height: 545px;
          background: #FFFFFF;
          margin: 16px;
          h2{
            position: relative;
            span{
              position: absolute;
              right: 20px;
              top: 18px;
            }
          }
          ul{
            li{
              display: flex;
              height: 48px;
              align-items: center;
              span{
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                color: #0D141E;
                &:nth-child(1){
                  font-size: 16px;
                  line-height: 22px;
                  width: 24px;
                  height: 24px;
                  text-align: center;
                  margin-left: 23px;
                }
                &:nth-child(2){
                  flex: 1;
                  text-align: left;
                  margin: 0 18px;
                }
                &:nth-child(3){
                  width: 80px;
                  text-align: right;
                  margin-right: 23px;
                }
              }
              &:nth-child(1) span:nth-child(1){ background: #F77981; color: #fff; }
              &:nth-child(2) span:nth-child(1){ background: #FFC130; color: #fff; }
              &:nth-child(3) span:nth-child(1){ background: #29CE42; color: #fff; }
            }
          }
          &:nth-child(2){
            margin: 16px 0;
          }
        }
      }
    }
    .no_data{
      text-align: center;
      img{
        width: 100px;
        margin-top: 50px;
      }
      p{
        margin-top: 15px;
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/dataStatistics/index.vue